export const locale = {
  terms_of_use: 'Terms of Use',
  privacy_policy: 'Privacy Policy',
  accessibility_statement: 'Accessibility Statement',
};
